import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Timer, Building2, Globe2 } from 'lucide-react';
interface SlideLocalRelevanceProps {
  onContinue: () => void;
}
export function SlideLocalRelevance({
  onContinue
}: SlideLocalRelevanceProps) {
  const [stage, setStage] = useState(0);
  useEffect(() => {
    const timers = [400, 1000, 1800, 2600].map((ms, idx) => setTimeout(() => setStage(idx + 1), ms));
    return () => timers.forEach(clearTimeout);
  }, []);
  return <div className="h-full w-full flex flex-col px-8 py-10 md:px-20 md:py-14 max-w-7xl mx-auto" data-id="element-763" data-mp="2xrs1w6269e0e">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="space-y-4" data-id="element-764" data-mp="2js0gvld8mxcw">
        <p className="text-teal-400 font-semibold tracking-widest uppercase text-sm" data-id="element-765" data-mp="18dn7flj8ekge">
          The Gap
        </p>
        <h2 className="text-4xl md:text-5xl font-serif text-white" data-id="element-766" data-mp="1cg9u7811pf6q">
          Local teams have no hours left for legacy brands
        </h2>
        <p className="text-xl text-white/60" data-id="element-767" data-mp="m22f006jg19z">
          The content exists. The attention to deploy it does not.
        </p>
      </motion.div>

      <div className="flex-1 flex flex-col justify-center max-w-5xl mx-auto w-full space-y-8" data-id="element-768" data-mp="v15w4ym5a6lu">
        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-6 items-center" data-id="element-769" data-mp="qz2jw7rnixzi">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: stage >= 1 ? 1 : 0,
          x: stage >= 1 ? 0 : -20
        }} className="bg-navy-700/40 border border-navy-600 rounded-2xl p-7 h-full flex flex-col" data-id="element-770" data-mp="14yk0hzusn4xs">
            <div className="w-12 h-12 rounded-xl bg-teal-400/10 text-teal-400 flex items-center justify-center mb-5" data-id="element-771" data-mp="19qbt0fxifkqk">
              <Globe2 className="w-6 h-6" data-id="element-772" data-mp="1nni922qun5c3" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-773" data-mp="1irt93yax3mf9">
              What global produces
            </h3>
            <p className="text-white/60 leading-relaxed" data-id="element-774" data-mp="gex1ox7lx4mv">
              Master content, claims and assets for the full portfolio —
              including the legacy and off-patent brands that still carry
              meaningful revenue.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scaleY: 0.4
        }} animate={{
          opacity: stage >= 2 ? 1 : 0,
          scaleY: stage >= 2 ? 1 : 0.4
        }} className="flex md:flex-col items-center justify-center gap-3" data-id="element-775" data-mp="u5ijeilbr8j6">
            <div className="hidden md:block w-[3px] h-16 bg-gradient-to-b from-transparent to-rose-400/50 rounded-full" data-id="element-776" data-mp="192j1rvhmlr4z" />
            <span className="px-3 py-1.5 rounded-full bg-rose-500/10 border border-rose-500/30 text-rose-400 text-xs font-semibold tracking-wide uppercase whitespace-nowrap" data-id="element-777" data-mp="1d10a2ics97nz">
              No capacity
            </span>
            <div className="hidden md:block w-[3px] h-16 bg-gradient-to-t from-transparent to-rose-400/50 rounded-full" data-id="element-778" data-mp="37bqd5dt4xwd7" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: stage >= 3 ? 1 : 0,
          x: stage >= 3 ? 0 : 20
        }} className="bg-navy-700/40 border border-navy-600 rounded-2xl p-7 h-full flex flex-col" data-id="element-779" data-mp="32ixaqwl5304a">
            <div className="w-12 h-12 rounded-xl bg-teal-400/10 text-teal-400 flex items-center justify-center mb-5" data-id="element-780" data-mp="3layeac8uzek1">
              <MapPin className="w-6 h-6" data-id="element-781" data-mp="3h8v03fut1vv2" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-782" data-mp="3hbh7nfhp4bda">
              What local can absorb
            </h3>
            <p className="text-white/60 leading-relaxed" data-id="element-783" data-mp="25u7neqqqtfax">
              Affiliates prioritise launch and growth brands. Legacy brands get
              whatever time is left over — which in most markets is none.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: stage >= 4 ? 1 : 0,
        y: stage >= 4 ? 0 : 12
      }} className="bg-rose-500/10 border border-rose-500/30 rounded-2xl px-7 py-6 flex items-start gap-4" data-id="element-784" data-mp="3oqhs5o5k6f88">
          <div className="w-10 h-10 shrink-0 rounded-xl bg-rose-500/20 text-rose-400 flex items-center justify-center" data-id="element-785" data-mp="bcwm2ly21tq5">
            <Timer className="w-5 h-5" data-id="element-786" data-mp="gcizavdvv9yy" />
          </div>
          <p className="text-white/90 text-lg leading-relaxed" data-id="element-787" data-mp="g9ws4wuwmwh9">
            The constraint is not relevance or personalization — it is{' '}
            <span className="text-rose-400 font-semibold" data-id="element-788" data-mp="7at7hog3a90n">
              local resource scarcity
            </span>
            . Low-attention brands need execution that requires no affiliate
            effort at all.
          </p>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: stage >= 4 ? 1 : 0
    }} className="mt-6 flex justify-end" data-id="element-789" data-mp="2rzh0r325hpxd"></motion.div>
    </div>;
}